<template>
    <div v-if="!loading">
        <shop-header />
        <main class="main">
            <router-view/>
        </main>
        <shop-footer />
        <modal-notification ref="notification"/>
        <b-alert :show="VUE_APP_MODE !== 'production'" id="debug-alert">
          <b>SITO DEMO</b>
          <br>
          vai su <a :href="prodUrl">{{ prodName }}</a>
        </b-alert>
    </div>
</template>

<script>
    //import Vue from 'vue'
    import { app_config } from '@/config'
    import ModalNotification from '@/components/modal-notification'
    import Header from '@/components/header/header'
    import Footer from '@/components/footer/footer'
    export default {
        name: 'app',
        metaInfo: {
          title: process.env.VUE_APP_SITE_PAYOFF,
          titleTemplate: '%s - ' + process.env.VUE_APP_SITE_TITLE,
          meta: [
            { vmid: 'metaTitle', name: 'Title', content: 'Prenota online hotel, beb, appartamenti. Semplice e sicuro!' },
            { vmid: 'metaDescription', name: 'Description', content: 'Prenota online i tuoi viaggi in modo semplice e soprattutto sicuro. ' + process.env.VUE_APP_SITE_TITLE + ', soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni' },
            { vmid: 'metaKeywords', name: 'Keywords', content: process.env.VUE_APP_SITE_TITLE + ', viaggi online, online travel booking, online travel agency, agenzia viaggi online, prenotazione online viaggi, viaggi welfare aziendale, viaggi welfare, viaggi promozioni, viaggi marketing, viaggi viaggi programmi fedeltà, viaggi programma fedeltà, viaggi loyalty program, catalogo a premi viaggi' },
            { vmid: 'metaAbstract', name: 'abstract', content: process.env.VUE_APP_SITE_TITLE + 'è un servizio di prenotazione viaggi online pensato per gli utenti del welfare aziendale. ' + process.env.VUE_APP_SITE_TITLE + ' offre soluzioni di online travel booking per i programmi fedeltà, per le promozioni e i concorsi' },
            { vmid: 'metaClassification', name: 'Classification', content: 'Commercial' },
            { vmid: 'metaResourceType', name: 'resource-type', content: 'document' },
            { vmid: 'metaDistribution', name: 'Distribution', content: 'Global' },
            { vmid: 'metaRating', name: 'Rating', content: 'General' },
            { vmid: 'metaLanguage', name: 'Language', content: 'IT' },
            { vmid: 'metaOwner', name: 'Owner', content: 'Salabam SRL' },
            { vmid: 'ogTitle', property: 'og:title', content: 'Prenota online in tempo reale hotel, beb, appartamenti e ville' },
            { vmid: 'ogSiteName', name: 'site_name', content: process.env.VUE_APP_SITE_TITLE + ' live booking' },
            { vmid: 'ogType', name: 'og:type', content: 'website' },
            { vmid: 'ogUrl', name: 'og:url', content: window.location.href },
            { vmid: 'ogImage', name: 'og:image', content: process.env.VUE_APP_SITE_HOST + 'assets/' + process.env.VUE_APP_OG_IMAGE },
            { vmid: 'ogImageWidth', name: 'og:image:width', content: '512' },
            { vmid: 'ogImageHeight', name: 'og:image:height', content: '512' },
            { vmid: 'ogDescription', name: 'og:description', content: 'Prenota online i tuoi viaggi in modo semplice e soprattutto sicuro. ' + process.env.VUE_APP_SITE_TITLE + ', soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni' },
            { vmid: 'dcTitle', name: 'DC.title', lang: 'it', content: 'Prenota online i tuoi viaggi in modo semplice e soprattutto sicuro. ' + process.env.VUE_APP_SITE_TITLE + ', soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni' },
            { vmid: 'dcCreator', name: 'DC.creator', content: 'Salabam SRL' },
            { vmid: 'dcSubject', name: 'DC.subject', lang: 'it', content: process.env.VUE_APP_SITE_TITLE + ';viaggi online;online travel booking;online travel agency;agenzia viaggi online;prenotazione online viaggi;viaggi welfare aziendale;viaggi welfare;viaggi promozioni;viaggi marketing;viaggi viaggi programmi fedeltà;viaggi programma fedeltà;viaggi loyalty program;catalogo a premi viaggi' },
            { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: process.env.VUE_APP_SITE_TITLE + 'è un servizio di prenotazione viaggi online pensato per gli utenti del welfare aziendale. ' + process.env.VUE_APP_SITE_TITLE + ' offre soluzioni di online travel booking per i programmi fedeltà, per le promozioni e i concorsi' },
            { vmid: 'dcType', name: 'DC.type', scheme: 'DCTERMS.DCMIType', content: 'Text' },
            { vmid: 'dcFormat', name: 'DC.format', content: 'text/html' },
            { vmid: 'dcIdentifier', name: 'DC.identifier', scheme: 'DCTERMS.URI', content: process.env.VUE_APP_SITE_HOST },
            { vmid: 'dcLanguage', name: 'DC.language', scheme: 'DCTERMS.RFC1766', content: 'IT' },
            { vmid: 'robots', name: 'robots', content: process.env.VUE_APP_META_ROBOTS },
          ]
        },
        components: {
            'modal-notification': ModalNotification,
            'shop-header': Header,
            'shop-footer': Footer,
        },
        data() {
            return {
              VUE_APP_MODE: process.env.VUE_APP_MODE,
              prodUrl: process.env.VUE_APP_PROD_URL,
              prodName: process.env.VUE_APP_PROD_NAME
            }
        },
        computed: {
            loading: {
                get()
                {
                    return this.$store.state.loading
                },
                set(value)
                {
                    this.$store.commit('set_loading', value)
                }
            }
        },
        beforeMount() {
            this.app_config = app_config
            let _this = this
            let wait_router_interval = setInterval(function() {
                // aspetto che il router carichi la rotta attuale, altrimenti app_config non riesce a leggere l'eventuale token in get
                if (_this.$route.name == null) return
                clearInterval(wait_router_interval)
                _this.app_config()
                    .then(() => {
                        _this.loading = false
                    })
            }, 100);
        },
        mounted() {
            let _this = this
                window.eventBus.$on('gotNotification', function(data) { 
                _this.$refs.notification.handle_notification(data)
            })
        },
        created () {
        },
        destroyed () {
        },
        methods: {
        }
    }
</script>

<style lang="scss">
    @import 'scss/_app.scss';
    .main
    {
        display:block;
        min-height: 100vh;
        //padding-top:$page-header-mobile-height;
        @include media-breakpoint-up(md)
        {
            //padding-top:$page-header-desktop-height;
        }
    }
</style>